function isEmptyObj(obj) {
  return Object.keys(obj).length === 0;
}

export default isEmptyObj;
